<section class="card page-card account-inactive-card" aria-labelledby="account-inactive-title">
  <div class="card-body">
    <span class="account-inactive-icon" aria-hidden="true">
      <fa-icon [icon]="faUserLock"></fa-icon>
    </span>

    <p class="account-inactive-kicker">Sign-in unavailable</p>
    <h2 id="account-inactive-title">Your account is inactive</h2>
    <p class="account-inactive-summary">
      Your CRD user account is currently inactive, so you cannot sign in.
    </p>

    <div class="account-inactive-guidance" role="note">
      <h3>Contact your agency administrator</h3>
      <p>
        Ask your agency administrator to activate your account. Once it has been activated,
        return to the login page and try again.
      </p>
    </div>

    <a class="btn btn-primary account-inactive-action" routerLink="/login">
      <fa-icon [icon]="faArrowLeft" aria-hidden="true"></fa-icon>
      Back to Login
    </a>
  </div>
</section>
